export const initialEntryFormData = Object.freeze({
    id: '',
    user_id: '',
    category_id: '',
    award_category: '',
    name: '',
    job_position: '',
    first_name: '',
    last_name: '',
    organization_name: '',
    organization_address_line_1: '',
    organization_address_line_2: '',
    organization_city: '',
    organization_province: '',
    organization_country: '',
    organization_address_type: '',
    organization_zip: '',
    organization_email: '',
    organization_phone: '',
    entry_summary: '',
    number_of_employees: '',
    financial_turnover: '',
    industry: '',
    other_industry: '',
    sub_market: '',
    supplier_1: '',
    supplier_2: '',
    supplier_3: '',
    supplier_4: '',
    website_url: '',
    twitter_url: '',
    linkedin_url: '',
    facebook_url: '',
    logo: '',
    document: '',
    privacy_policy: '',
    terms_of_service: '',
    organization_logo: '',
    trophy_first_name: '',
    trophy_last_name: '',
    trophy_job_position: '',
    trophy_organization_name: '',
    trophy_organization_email: '',
    trophy_organization_phone: '',
    status: '',
    from_website: 0,
});